import { gql } from '@apollo/client';

export type ExternalStationItem = {
  id: number;
  name: string;
  sortingCode: string | null;
  carrierCode: number | null;
  addressName: string | null;
  stationType: number | null;
  addressLine1: string;
  addressLine2: string | null;
  contactName: string | null;
  phoneNumber: string | null;
  timezoneLocation: string;
  country: string | null;
  state: string | null;
  city: string | null;
  zipcode: string | null;
  temuWarehouseId: string | null;
  isTest: boolean;
  isDeleted: boolean;
  updatedAt: number | null;
};

export type ExternalStationFilterInput = {
  name?: string;
  stationType?: number;
  isDeleted?: boolean;
};

export type ExternalStationPageResponse = {
  getExternalStationsWithPagination: {
    content: ExternalStationItem[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
};

export const GET_EXTERNAL_STATIONS_WITH_PAGINATION = gql`
  query GetExternalStationsWithPagination(
    $filter: ExternalStationFilterInput
    $pageRequest: PageRequestTypeInput
  ) {
    getExternalStationsWithPagination(filter: $filter, pageRequest: $pageRequest) {
      content {
        id
        name
        sortingCode
        carrierCode
        addressName
        stationType
        addressLine1
        addressLine2
        contactName
        phoneNumber
        timezoneLocation
        country
        state
        city
        zipcode
        temuWarehouseId
        isTest
        isDeleted
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
